import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'recompose';
import { InlineRichText } from '@nextiva/rich-text-editor';

import StylingTextOptionToRTEProps from 'styling/hocs/StylingToRTEProps/StylingTextOptionToRTEProps';
import withNewKeyOnLocalFontChange from 'styling/hocs/withNewKeyOnLocalFontChange';
import { optionPropTypes } from 'sharedParts/config/blockConfig/settings/optionListPropTypes';

import MatrixRow from '../../layout/MatrixRow';
import MatrixCell from '../../layout/MatrixCell';
import getRichContentFromOptionModel from '../../../../utils/getRichContentFromOptionModel';
import styles from './MatrixInputGroup.scss';

class MatrixInputGroup extends Component {
  static propTypes = {
    renderKey: PropTypes.string.isRequired,
    meta: PropTypes.object.isRequired,
    option: optionPropTypes,
    defaultFontSize: PropTypes.number.isRequired,
    defaultFont: PropTypes.string.isRequired,
    defaultFontColor: PropTypes.string.isRequired,
    defaultBold: PropTypes.bool.isRequired,
    defaultItalic: PropTypes.bool.isRequired,
    defaultUnderline: PropTypes.bool.isRequired,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node,
    ]),
    form: PropTypes.string.isRequired,
  };

  render() {
    const {
      renderKey,
      meta: { submitFailed, invalid },
      option,
      children,
      form,
      defaultFontSize,
      defaultFont,
      defaultFontColor,
      defaultBold,
      defaultItalic,
      defaultUnderline,
    } = this.props;

    return (
      <MatrixRow className={styles.row} form={form}>
        <MatrixCell
          key={renderKey} // TODO #001 Remove renderKey by updating RTE  @sinslav
          errorColored={submitFailed && invalid}
          className={styles.optionText}
          contentClassName={styles.plainText}
          cellRenderer={InlineRichText}
          defaultFontSize={defaultFontSize}
          defaultFont={defaultFont}
          defaultFontColor={defaultFontColor}
          defaultBold={defaultBold}
          defaultItalic={defaultItalic}
          defaultUnderline={defaultUnderline}
          value={getRichContentFromOptionModel(option)}
        />
        {children}
      </MatrixRow>
    );
  }
}

export default compose(
  StylingTextOptionToRTEProps,
  withNewKeyOnLocalFontChange,
)(MatrixInputGroup);
